var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"d-inline-flex",attrs:{"color":"primary","small":"","flat":""},on:{"click":_vm.openCreativePage}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("open_in_new")]),_c('span',{staticStyle:{"padding-left":"5px"}},[_vm._v("クリエイティブ追加")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }